import API from './api';

export const attendanceService = {
  // Get attendance records
  getAttendance: (params) => API.get('/attendance', { params }),

  // Record attendance
  recordAttendance: (data) => API.post('/attendance/record', data),

  // Request attendance regularization
  requestRegularization: (data) => API.post('/attendance/regularization', data),

  // Get regularization requests
  getRegularizationRequests: (params) => API.get('/attendance/regularization', { params }),

  // Process regularization request
  processRegularization: (id, data) => API.put(`/attendance/regularization/${id}`, data),

  // Get attendance summary for employee
  getAttendanceSummary: (employeeId, params) => API.get(`/attendance/summary/${employeeId}`, { params }),

  // Get attendance calendar
  getAttendanceCalendar: (params) => API.get('/attendance/calendar', { params }),
};
